import { ApplicationInitStatus, Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { cloneDeep } from 'lodash';
import { CartItem } from 'src/app/modals/cart-item';
import { UserServiceModal } from 'src/app/modals/userservice.modal';
import { CartService } from './cart.service';
import { NotificationService } from './notification.service';
import { ProductService } from './product.service';
import { RestApiService } from './restapi.service';
import { UserService } from './user.service';
import { ConfigService } from './config.service';
import { UtilityService } from './utility.service';
import { CompanyService } from './company.service';
import { ShoppingCartService } from './shopping-cart.service';
import { ShippingMethodService } from './shipping-method.service';
import { PersistentService } from './persistent.service';
import { Router } from '@angular/router';
import { AUTOSHIPSTOREID, CORPORATESTOREID, DefaultCountry, FreeEnrollmentItemID, FreeEnrollmentZeroPriceItemID, IBOSTOREID, RETAILSTOREID } from 'src/app/constant';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  public calculateOrderResponse: any = {};
  public calculateAutoOrderResponse: any = {};
  public lastRequest = {};
  public lastAutoOrderRequest = {};
  shoppingCartItems: CartItem[] = [];
  public packTotal = 0;
  public packBusinessVolume = 0;
  public orderTotal = 0;
  public orderRewardTotal = 0;
  public orderBusinessVolume = 0;
  public autoorderBusinessVolume = 0;
  public PreventTaxJarCalculation: boolean = true;
  public UsePoints: boolean = false;
  public calculateOrderCall: boolean;
  public userService: UserServiceModal;
  autoshipStoreId: any;
  retailStoreId: any;
  enrollStoreId: any;
  public isFirstOrder: boolean = false;  // Flag for first order free shipping eligibility

  constructor(
    public user: UserService,
    public notificationService: NotificationService,
    private router: Router,
    public route: ActivatedRoute,
    public cartService: CartService,
    public apiService: RestApiService,
    public translate: TranslateService,
    public itemsService: ProductService,
    public configService: ConfigService,
    public appInit: ApplicationInitStatus,
    public utilityService: UtilityService,
    public companyService: CompanyService,
    public shoppingCartService: ShoppingCartService,
    public shippingMethodService: ShippingMethodService,
    public persistentService: PersistentService,
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let currentRoute = this.route;
        while (currentRoute.firstChild) {
          currentRoute = currentRoute.firstChild;
        }

        this.userService = this.user.userServiceModal;
        appInit.donePromise.then(() => this.onInit());
        this.getstoreId();
      }
    });
  }

  onInit(): void {
    this.cartService.getItems().subscribe(shoppingCartItems => this.shoppingCartItems = shoppingCartItems);
    if ((this.itemsService.selectedOrderItems || this.itemsService.selectedPacks) && this.itemsService.selectedOrderItems.length > 0) {
      this.calculateOrder();
    }
    if (this.itemsService.selectedAutoOrderItems && this.itemsService.selectedAutoOrderItems.length > 0) {
      this.calculateAutoOrder();
    }
  }

  /*** calculate Order ***/
  public calculateOrder(showNotification?: boolean, walletUsedPoints?: number): any {
    const promise = new Promise((resolve, reject) => {
      let orderSubtotal = 0;
      const productdetails = [];
      const kititems = [];

      this.itemsService.selectedOrderItems.forEach((item, index) => {
        orderSubtotal += (item.Price || 0) * (item.Quantity || 1);
        productdetails.push({
          ItemId: item.ItemID,
          Quantity: item.Quantity || 1,
          // IsReward: false, // item.UsePoints
        });
      });

      this.itemsService.selectedPacks.forEach((item, index) => {
        orderSubtotal += (item.Price || 0) * (item.Quantity || 1);
        productdetails.push({
          ItemId: item.ItemID,
          Quantity: item.Quantity || 1,
          // IsReward: false
        });
      });

      if (this.userService?.couponInfo?.promoCode) {
        const isInCart = this.userService.couponInfo.Allcoupons.some((code) => {
          if (code == this.userService.couponInfo.promoCode) {
            return true;
          }
          return false;
        });
        if (!isInCart) {
          this.userService.couponInfo.Allcoupons.push(this.userService.couponInfo.promoCode);
        }
      }
      const token = null; // cookieService.getAuthToken();
      const guestLogin = sessionStorage.getItem('guestLogin') == 'true' ? true : false;
      if (token && !guestLogin) {
        const selectedorders = JSON.parse(sessionStorage.getItem('cart.order'));
        if (!selectedorders || !selectedorders.length) {
          this.userService.couponInfo.RewardsForUse = [];
          this.userService.couponInfo.promoCode = '';
          this.userService.couponInfo.promoCodeValid = true;
          this.userService.couponInfo.IsAppliedcode = false;
          this.userService.couponInfo.Allcoupons = [];
        }
      }
      this.CustomerTypeChanged();
      const selectedCountry = this.configService.commonData.selectedCountry || DefaultCountry;
      const addressData = this.configService.commonData?.CountryCode?.[selectedCountry];
      // For enrollment flow, always treat as first order for free shipping
      // Check enrollment status directly to handle timing issues
      const isEnrollmentFlow = this.utilityService.isEnrollment();
      const effectiveIsFirstOrder = isEnrollmentFlow ? true : this.isFirstOrder;
      // Pass isFirstOrder flag for first order free shipping eligibility (US only)
      const shipMethodId = this.shippingMethodService.getShippingMethodId(orderSubtotal, this.userService?.customerTypeID, this.isAutoshipAvail(), walletUsedPoints || 0, effectiveIsFirstOrder) || this.userService?.selectedShippingMethod;

      // Ensure country code is in uppercase format
      const countryCode = (this.userService?.selectedCountry || this.configService.commonData.selectedCountry || DefaultCountry).toUpperCase();

      // For enrollment/first order, always prioritize the calculated free shipping method
      // Otherwise, allow user's selected shipping method to take precedence
      const finalShipMethodId = effectiveIsFirstOrder ? shipMethodId : (this.userService.selectedShippingMethod || shipMethodId);

      const calculateOrderRequest = {
        customerType: this.isLoggedIn() ? (this.itemsService?.selectedAutoOrderItems?.length > 0 ? (this.userService?.customerTypeID == 1 ? 1 : 3) : this.userService?.customerTypeID || 2) : this.userService?.customerTypeID || 2,
        // customerType: (sessionStorage.getItem('IsEnrollment') != 'true' && this.itemsService.selectedAutoOrderItems?.length > 0) ? 3 : this.userService.enrollerInfo?.CustomerType ||1,
        customerId: this.isLoggedIn() ? (this.userService.customerData?.CustomerId ? this.userService.customerData?.CustomerId : this.userService.enrollerInfo?.CustomerId) : "",
        OrderId: "",
        calculateOrder: {
          // WarehouseId: 0,
          ShipMethodId: finalShipMethodId,
          StoreId: (!this.isLoggedIn() && this.userService?.customerTypeID == 1) ? IBOSTOREID : this.user?.userServiceModal?.customerData?.IsCorporate == true ? CORPORATESTOREID : RETAILSTOREID,
          CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
          ShippingAddress: {
            AddressId: 0,
            Street1: this.userService?.shippingAddress?.Street1 || addressData?.Line1,
            Street2: this.userService?.shippingAddress?.Street2 || addressData?.Line2,
            Street3: ' ',
            PostalCode: this.userService?.shippingAddress?.PostalCode || this.userService?.shippingAddress?.PostalCode || addressData?.Zip,
            City: this.userService?.shippingAddress?.City || addressData?.City,
            Region: this.userService?.shippingAddress?.Region ? this.userService?.shippingAddress.Region : (this.userService?.defaultState || this.userService?.regionMainState) || addressData?.StateCode,
            CountryCode: countryCode
          },
          PriceGroup: this.userService?.customerTypeID || 2,
          OrderType: 1,
          KitItems: [],
          Items: productdetails,
          PartyId: 0,
          CouponCodes: this.configService.localSettings.Global.OrderAllowCoupons ? (this.userService?.couponInfo?.Allcoupons || []) : [],
          CountryCode: countryCode,
          CustomShippingAddress: [{
            Line1: this.userService?.shippingAddress?.Street1 || addressData?.Line1,
            Line2: this.userService?.shippingAddress?.Street2 || addressData?.Line2,
            Zip:
              this.userService?.shippingAddress?.PostalCode ||
              this.userService?.shippingAddress?.PostalCode ||
              addressData?.Zip,
            City: this.userService?.shippingAddress?.City || addressData?.City,
            StateCode: this.userService?.shippingAddress?.Region
              ? this.userService?.shippingAddress?.Region
              : this.userService?.defaultState ||
              this.userService?.regionMainState ||
              addressData?.StateCode,
            CountryCode: countryCode,
          }],
          ...(walletUsedPoints && walletUsedPoints > 0 && { WalletUsedPoints: walletUsedPoints })
        }
      };

      // Modified logic to ensure API calls are made when quantities change
      const shouldMakeApiCall = !_.isEqual(this.lastRequest, calculateOrderRequest) || 
                               this.persistentService.retailData.isChanged ||
                               showNotification;

      if (!shouldMakeApiCall) {
        resolve(this.calculateOrderResponse);
        return;
      }

      this.lastRequest = cloneDeep(calculateOrderRequest);

      if (productdetails.length == 0) {
        if (this.userService.customerTypeID !== 1) {
          // this.router.navigate(['/products/all']);
        }
        else {
          resolve(this.calculateOrderResponse);
          return;
        }
      }
      if (this.itemsService.selectedOrderItems.length == 0) {
        // No order items - if autoship items exist, calculate autoship instead
        if (this.itemsService.selectedAutoOrderItems?.length > 0) {
          this.calculateAutoOrder().then(resolve).catch(reject);
        } else {
          resolve(this.calculateOrderResponse);
        }
        return;
      }
      this.apiService.calculateCustomerOrderTotal(calculateOrderRequest).subscribe((result) => {

          // if(result.Data.Item == 0){
          //   this.router.navigate(['/products/all']);
          // }
          this.calculateOrderCall = false;
          try {
            var isLoggedIn = sessionStorage.getItem('isLoggedIn') || '';
            //if (isLoggedIn && (parseInt(result.Status, 10) === 0)) {
            this.abandonedCart('Standard', result.Data.Items, result.Data.Total)
            //}
          } catch (error) {
            console.log('error', error);
          }
          try {
            if (parseInt(result.Status, 10) === 0) {
              this.calculateOrderResponse = result.Data;
              this.calculateOrderResponse.ShippingMethods = result.Data.ShippingMethods;
              if (this.calculateOrderResponse.CouponResults) {
                this.calculateOrderResponse.CouponResults.forEach((item, index) => {
                  const isInCart = this.userService.couponInfo.Allcoupons.some((code) => {
                    if (code.toLowerCase() == item.Code.toLowerCase()) {
                      return true;
                    }
                    return false;
                  });

                  if (item.IsValid) {
                    if (!isInCart) {
                      this.userService.couponInfo.Allcoupons.push(item.Code);
                    }
                    if (this.userService.couponInfo.promoCode == item.Code) {
                      this.notificationService.success('success', 'coupon_added_success');
                    }

                    this.userService.couponInfo.promoCodeValid = true;

                  } else {
                    this.userService.couponInfo.promoCodeValid = false;
                    this.userService.couponInfo.IsAppliedcode = false;
                    this.userService.couponInfo.promoCode = '';
                    if (isInCart && this.itemsService.selectedOrderItems.length) {
                      this.userService.couponInfo.Allcoupons = this.userService.couponInfo.Allcoupons.filter((code) => {
                        return code.toLowerCase() != item.Code.toLowerCase();
                      });
                      this.userService.couponInfo.RewardsForUse = this.userService.couponInfo.RewardsForUse.filter((e) => {
                        return e.Code.toLowerCase() != item.Code.toLowerCase();
                      });

                    }
                  }

                });
              }
              this.userService.couponInfo.promoCode = '';
              setTimeout(() => {
                this.userService.shippingMethods = result.Data.ShippingMethods;

                if (this.userService.shippingMethods && this.userService.shippingMethods.length) {
                  const selectedShipmethod = this.userService.shippingMethods.filter((shipMethod) => {
                    return (shipMethod.ShipMethodId === this.userService.selectedShippingMethod);

                  });
                  if (selectedShipmethod.length > 0) {
                    this.userService.selectedShippingMethod = this.userService.selectedShippingMethod ||
                      selectedShipmethod[0].ShipMethodId;

                  } else {
                    this.userService.selectedShippingMethod = this.userService.selectedShippingMethod ||
                      this.userService.shippingMethods[0].ShipMethodId;
                  }

                }
              }, 100);

              // pack total
              if (this.itemsService.selectedPacks.length) {
                this.packTotal = 0;
                this.packBusinessVolume = 0;
                const selectedPacks = cloneDeep(this.itemsService.selectedPacks);
                this.itemsService.selectedPacks = [];
                selectedPacks.forEach((item) => {
                  this.calculateOrderResponse.Items.forEach((item1) => {
                    if (item.ItemID == item1.ItemId) {
                      // Update pack item price from API response
                      item.Price = item1.Price || item1.PriceEach || item.Price;
                      this.packTotal = this.packTotal + (item.Quantity * item.Price);
                      this.packBusinessVolume = this.packBusinessVolume + (item.Quantity * (item.BusinessVolume || item.QV));
                      this.itemsService.selectedPacks.push(item);
                    }
                  });
                });
              }
              // order total
              if (this.itemsService.selectedOrderItems.length) {
                this.orderTotal = 0;
                this.orderRewardTotal = 0;
                this.orderBusinessVolume = 0;
                const selectedOrderItems = cloneDeep(this.itemsService.selectedOrderItems);
                this.itemsService.selectedOrderItems = [];
                selectedOrderItems.forEach((item) => {
                  this.calculateOrderResponse.Items.forEach((item1) => {
                    if (item1.CurrencyCode == 'RWD') {
                      item1.UsePoints = true;
                    }

                    if (item.ItemID == item1.ItemId && !!item.UsePoints == !!item1.UsePoints) {
                      item.Price = item1.Price || item1.PriceEach || item.Price;
                      if (item1.CurrencyCode == 'RWD') {
                        this.orderRewardTotal = this.orderRewardTotal + (item1.Quantity * (item1.Price || item1.PriceEach || 0));
                      }
                      else {
                        this.orderTotal = this.orderTotal + (item1.Quantity * (item1.Price || item1.PriceEach || 0));
                      }
                      item1.BusinessVolumeTotal = this.orderBusinessVolume + ((item1.Cv || item1.QV || 0));
                      this.orderBusinessVolume = this.orderBusinessVolume + ((item1.Cv || item.QV || 0));
                      this.itemsService.selectedOrderItems.push(item);
                    }
                  });
                });
              }
              if (showNotification) {
                this.notificationService.success('success', this.translate.instant('item_added_your_order_shopping_cart'));
              }
              resolve(result);
            } else {
              const getMessage = result.Message.toLowerCase().includes('Api returned 404 Not Found'.toLowerCase());
              let getItemName;
              if (getMessage && getMessage !== null) {
                const getNumber = result.Message;
                const getItemCode = getNumber.match(new RegExp('Item with Id' + '\\s(\\w+)'))[1]; // getNumber.replace(/\D/g, '');
                let getItemDetails = this.itemsService.selectedOrderItems;
                if (this.itemsService.selectedPacks.length > 0) {
                  getItemDetails = getItemDetails.concat(this.itemsService.selectedPacks);
                }
                getItemDetails.forEach((item, index) => {
                  if (item.ItemID == getItemCode) {
                    getItemName = item.ProductName;
                  }
                });

                this.translate.get('error_item_not_found').subscribe((text: string) => {
                  this.notificationService.error('error_', this.translate.instant('error_item_not_found') + ' ' + getItemName);
                });

              } else {
                this.notificationService.error('error_', result.Message);
              }

              reject(result);
            }
          } catch (ex) {

            this.notificationService.error('error_', 'error_occured_try_again');
            reject(ex);
          }
        }, (error) => {
          // this.calculateOrderCall = false;
          reject(error);
        });
      });
    return promise;
  }

  /***calculate Auto Order***/
  public calculateAutoOrder(showNotification?: boolean, editAutoship?: boolean): any {
    const promise = new Promise((resolve, reject) => {
      this.PreventTaxJarCalculation = true;
      let orderSubtotal = 0;
      const productdetails = [];
      this.itemsService.selectedAutoOrderItems.forEach((item, index) => {
        const itemTotal = (item.AutoshipPrice || 0) * (item.Quantity || 1); // Ensure price and quantity exist
        orderSubtotal += itemTotal;
        productdetails.push({
          ItemId: item.ItemID,
          Quantity: item.Quantity,
          IsKitItem: false
        });
      });
      // this.CustomerTypeChanged();
      const selectedCountry = this.configService.commonData.selectedCountry || DefaultCountry;
      const addressData = this.configService.commonData?.CountryCode?.[selectedCountry];
      // For enrollment flow, always treat as first order for free shipping (same as calculateOrder)
      const isEnrollmentFlow = this.utilityService.isEnrollment();
      const effectiveIsFirstOrder = isEnrollmentFlow ? true : this.isFirstOrder;
      // Pass isFirstOrder flag for first order free shipping eligibility (US only)
      const shipMethodId = this.shippingMethodService.getShippingMethodId(orderSubtotal, this.userService?.customerTypeID, this.isAutoshipAvail(), 0, effectiveIsFirstOrder) || this.userService?.selectedShippingMethod || "11";

      // For enrollment/first order, always prioritize the calculated free shipping method
      // Otherwise, allow user's selected shipping method to take precedence
      const finalShipMethodId = effectiveIsFirstOrder ? shipMethodId : (this.userService.selectedShippingMethod || shipMethodId);

      const calculateOrderRequest = {
        customerType: this.isLoggedIn() ? (this.itemsService?.selectedAutoOrderItems?.length > 0 ? (this.userService?.customerTypeID == 1 ? 1 : 3) : this.userService?.customerTypeID || 2) : this.userService?.customerTypeID || 2,
        customerId: this.userService?.customerData?.CustomerId,
        OrderId: "",
        calculateOrder: {
          // WarehouseId: 0,
          ShipMethodId: finalShipMethodId,
          StoreId: this.autoshipStoreId || AUTOSHIPSTOREID,
          CurrencyCode: this.companyService.selectedCurrency.CurrencyCode || "USD",
          ShippingAddress: {
            AddressId: 0,
            Street1: this.userService?.shippingAddress?.Street1 || addressData?.Line1,
            Street2: this.userService?.shippingAddress?.Street2 || addressData?.Line2,
            Street3: '',
            PostalCode: this.userService?.shippingAddress?.PostalCode || this.userService?.shippingAddress?.PostalCode || addressData?.Zip,
            City: this.userService?.shippingAddress?.City || addressData?.City,
            Region: this.userService?.shippingAddress?.Region
              ? this.userService?.shippingAddress.Region : (this.userService?.defaultState || this.userService?.regionMainState) || addressData?.StateCode,
            // || this.itemsService.getState() || this.userService.shippingAddress.MainState);,
            CountryCode: this.userService?.selectedCountry || selectedCountry
          },
          PriceGroup: this.userService?.customerTypeID || 2,
          OrderType: 2,
          KitItems: [],
          Items: productdetails,
          PartyId: 0,
          CouponCodes: this.configService.localSettings.Global.OrderAllowCoupons ? (this.userService?.couponInfo?.Allcoupons || []) : [],
          CountryCode: this.userService?.selectedCountry || selectedCountry || DefaultCountry,
          CustomShippingAddress: [{
            Line1: this.userService?.shippingAddress?.Street1 || addressData?.Line1,
            Line2: this.userService?.shippingAddress?.Street2 || addressData?.Line2,
            Zip:
              this.userService?.shippingAddress?.PostalCode ||
              this.userService?.shippingAddress?.PostalCode ||
              addressData?.Zip,
            City: this.userService?.shippingAddress?.City || addressData?.City,
            StateCode: this.userService?.shippingAddress?.Region
              ? this.userService?.shippingAddress?.Region
              : this.userService?.defaultState ||
              this.userService?.regionMainState ||
              addressData?.StateCode,
            CountryCode: this.userService?.selectedCountry || selectedCountry,
          }]
        }
      };
      // Modified logic to ensure API calls are made when quantities change
      const shouldMakeApiCall = (!editAutoship && !_.isEqual(this.lastAutoOrderRequest, calculateOrderRequest)) || 
                               this.persistentService.retailData.isChanged ||
                               showNotification;

      if (!shouldMakeApiCall) {
        resolve(this.calculateAutoOrderResponse);
        return;
      }

      this.lastAutoOrderRequest = cloneDeep(calculateOrderRequest);

      if (productdetails.length == 0) {
        resolve(this.calculateAutoOrderResponse);
        return;
      }
      if (this.itemsService.selectedAutoOrderItems.length == 0) {
        resolve(this.calculateAutoOrderResponse);
        return;
      }
      this.apiService.calculateCustomerOrderTotal(calculateOrderRequest).subscribe((result) => {
          try {
            var isLoggedIn = sessionStorage.getItem('isLoggedIn') || '';
            // if (isLoggedIn && (parseInt(result.Status, 10) === 0)) {
            this.abandonedCart('Autoship', result.Data.Items, result.Data.Total)
            // }
          } catch (error) {
          }
          try {

            if (parseInt(result.Status, 10) === 0) {
              this.calculateAutoOrderResponse = result.Data;
              this.calculateAutoOrderResponse.ShippingMethods = result.Data.ShippingMethods;
              if (showNotification) {
                this.notificationService.success('success', this.translate.instant('item_added_in_your_autoship'));
              }
              this.autoorderBusinessVolume = 0;
              const selectedAutoOrderItems = cloneDeep(this.itemsService.selectedAutoOrderItems);
              this.itemsService.selectedAutoOrderItems = [];
              selectedAutoOrderItems.forEach((autoitem, index) => {
                this.calculateAutoOrderResponse.Items.forEach((item1) => {
                  if (autoitem.ItemID == item1.ItemId) {
                    autoitem.Price = item1.Price || item1.PriceEach;
                    autoitem.BusinessVolumeTotal = this.autoorderBusinessVolume + ((item1.Cv || item1.Qv || 0));
                    this.autoorderBusinessVolume = this.autoorderBusinessVolume + ((item1.Cv || item1.Qv || 0));
                  }
                });
              });
              if(this.itemsService.selectedOrderItems?.length == 0){
                this.userService.selectedShippingMethod = this.calculateAutoOrderResponse?.ShippingMethods[0]?.ShipMethodId;
              }
              if (this.userService.shippingMethods && this.userService.shippingMethods.length) {
                const selectedShipmethod = this.userService.shippingMethods.filter((shipMethod) => {
                  return (shipMethod.ShipMethodID === this.userService.selectedShippingMethod);

                });
                if (selectedShipmethod.length > 0) {
                  this.userService.selectedShippingMethod = this.userService.selectedShippingMethod || selectedShipmethod[0].ShipMethodID;
                }
                else {
                  this.userService.selectedShippingMethod = this.userService.selectedShippingMethod ||
                    this.userService.shippingMethods[0].ShipMethodID;
                }
              }
              this.itemsService.selectedAutoOrderItems = selectedAutoOrderItems;
              resolve(result);
            } else {
              const getMessage = result.Message.toLowerCase().includes('Api returned 404 Not Found'.toLowerCase());
              let getItemName;
              if (getMessage && getMessage !== null) {
                const getNumber = result.Message;
                const getItemCode = getNumber.match(new RegExp('Item with Id' + '\\s(\\w+)'))[1]; // getNumber.replace(/\D/g, '');
                const getItemDetails = this.itemsService.selectedAutoOrderItems;
                getItemDetails.forEach((item, index) => {
                  if (item.ItemID == getItemCode) {
                    getItemName = item.ProductName;
                  }
                });

                this.translate.get('error_item_not_found').subscribe((text: string) => {
                  this.notificationService.error('error_', this.translate.instant('error_item_not_found') + ' ' + getItemName);
                });
              } else {
                this.notificationService.error('error_', result.Message);
              }
              reject(result);
            }
          } catch (ex) {

            this.notificationService.error('error_', 'error_occured_try_again');
            reject(ex);
          }
        }, (error) => {
          reject(error);
        });
      });
    return promise;
  }

  public abandonedCart(type, items, total) {
    var data1: any;
    var cartItems: any = [];
    if (items.length > 0) {
      items.forEach(element => {
        cartItems.push({
          "itemId": element.ItemId,
          "productName": element.ProductName,
          "sku": element.Sku,
          "quantity": element.Quantity,
          "qv": element.Qv,
          "cv": element.Cv,
          "bonus": element.Bonus,
          "price": element.price,
          "languageCode": element.LanguageCode,
          "currencyCode": element.CurrencyCode
        });
      });
    }
    try {
      if (this.user.userServiceModal && Object.keys(this.user.userServiceModal.customerData).length > 0) {
        data1 = [{
          "type": type,
          "cartItem": cartItems,
          "price": total,
          "enrollerInfo": {
            "customerId": parseInt(this.userService.enrollerInfo.CustomerId, 10),
            "backOfficeId": this.userService.enrollerInfo.BackOfficeId,
            "firstName": this.userService.enrollerInfo.FirstName,
            "lastName": this.userService.enrollerInfo.LastName,
            "webAlias": this.userService.enrollerInfo.WebAlias,
            "phoneNumber": this.userService.enrollerInfo.PrimaryPhone,
            "emailAddress": this.userService.enrollerInfo.EmailAddress,
            "country": this.userService.enrollerInfo.Country,
            "region": this.userService.enrollerInfo.Region
          },
          "customerInfo": {
            "customerId": this.user.userServiceModal.customerData.CustomerId ? parseInt(this.user.userServiceModal.customerData.CustomerId) : 0,
            "backOfficeId": this.user.userServiceModal.customerData.BackOfficeId ? this.user.userServiceModal.customerData.BackOfficeId : '',
            "firstName": this.user.userServiceModal.customerData.FirstName ? this.user.userServiceModal.customerData.FirstName : '',
            "lastName": this.user.userServiceModal.customerData.LastName ? this.user.userServiceModal.customerData.LastName : '',
            "webAlias": this.user.userServiceModal.customerData.WebAlias ? this.user.userServiceModal.customerData.WebAlias : '',
            "phoneNumber": this.user.userServiceModal.customerData.PrimaryPhone ? this.user.userServiceModal.customerData.PrimaryPhone : '',
            "emailAddress": this.user.userServiceModal.customerData.EmailAddress ? this.user.userServiceModal.customerData.EmailAddress : '',
            "country": this.user.userServiceModal.customerData.PrimaryAddress.CountryCode ? this.user.userServiceModal.customerData.PrimaryAddress.CountryCode : '',
            "region": this.user.userServiceModal.customerData.PrimaryAddress.Region ? this.user.userServiceModal.customerData.PrimaryAddress.Region : this.user.userServiceModal.customerData.PrimaryAddress.Region,
          }
        }]
      }
      else {
        data1 = [{
          "type": type,
          "cartItem": cartItems,
          "price": total,
          "enrollerInfo": {
            "customerId": parseInt(this.userService.enrollerInfo.CustomerId),
            "backOfficeId": this.userService.enrollerInfo.BackOfficeId,
            "firstName": this.userService.enrollerInfo.FirstName,
            "lastName": this.userService.enrollerInfo.LastName,
            "webAlias": this.userService.enrollerInfo.WebAlias,
            "phoneNumber": this.userService.enrollerInfo.PrimaryPhone,
            "emailAddress": this.userService.enrollerInfo.EmailAddress,
            "country": this.userService.enrollerInfo.Country,
            "region": this.userService.enrollerInfo.Region
          },
          "customerInfo": {
          }
        }]
      }
      var tempData = JSON.stringify(data1);
      window['ZTM'].setStats('commonsense', 'AbandonedCart', tempData);
    } catch (error) {
    }
  }

  /** *Reset last requests
   * @method  resetLastRequests
   * Reset last requests in case of continue shoppings.
   */
  public resetLastRequests(): any {
    this.lastRequest = {};
    this.lastAutoOrderRequest = {};
  }

  getstoreId() {
    this.apiService.getStores().subscribe((result) => {
      this.autoshipStoreId = "5";
      this.retailStoreId = "3";
      this.enrollStoreId = "4";
    })
  }

  isLoggedIn(): boolean {
    let isLoggedIn = false;
    this.apiService.loginStatus.subscribe(val => {
      isLoggedIn = val;
    });
    return isLoggedIn;
  }

  CustomerTypeChanged() {
    if (this.itemsService.selectedPacks.length == 0) {
      const freeEnrollmentItem = this.itemsService.selectedOrderItems.includes((item) => item.ItemID == FreeEnrollmentItemID);
      const freeEnrollmentZeroPriceItemID = this.itemsService.selectedOrderItems.includes((item) => item.ItemID == FreeEnrollmentZeroPriceItemID);
      if (!freeEnrollmentItem && !freeEnrollmentZeroPriceItemID && !this.router.url.includes('join')) {
        if (this.itemsService.selectedAutoOrderItems.length > 0) {
          this.userService.customerTypeID = !this.isLoggedIn() ? 3 : this.userService?.customerData?.CustomerType;
        }
        else {
          this.userService.customerTypeID = !this.isLoggedIn() ? 2 : this.userService?.customerData?.CustomerType;
        }
      }
      else {
        this.userService.customerTypeID = 1;
      }
    } else {
      this.userService.customerTypeID = 1;
    }
  }

  isAutoshipAvail() {
    if (this.itemsService.selectedAutoOrderItems?.length > 0) {
      return true;
    }
    else {
      return false;
    }
  }

  /**
   * Checks if this is the customer's first order for free shipping eligibility
   * First order free shipping applies only to US customers
   * This method should be called when a customer logs in or during checkout initialization
   *
   * Uses OrderCount from GetCustomer API response (added by BE team)
   */
  checkIfFirstOrder(): void {
    // Default to false for safety - only set true when we're certain it's a first order
    this.isFirstOrder = false;

    // If editing an existing autoship, it's not a first order
    if (this.utilityService.getAutoshipEditFlag()) {
      this.isFirstOrder = false;
      return;
    }

    // Check if this is an enrollment flow - enrollments are always first orders
    if (this.utilityService.isEnrollment()) {
      this.isFirstOrder = true;
      return;
    }

    // Use user.userServiceModal directly to get the latest customerData
    // (this.userService may not be initialized yet if router event hasn't fired)
    const customerData = this.user?.userServiceModal?.customerData;

    // If user is logged in (has CustomerId), they are an existing customer
    // Only give free shipping if OrderCount is explicitly 0
    if (customerData?.CustomerId) {
      // Use OrderCount from GetCustomer API response (provided by BE team)
      if (customerData.OrderCount !== undefined && customerData.OrderCount !== null) {
        this.isFirstOrder = customerData.OrderCount === 0;
        return;
      }

      // Fallback: check order history via API for logged-in users
      this.apiService.getCustomerOrders(customerData.CustomerId).subscribe(
        (result: any) => {
          if (result && result.Data) {
            // If no previous orders, this is the first order
            this.isFirstOrder = result.Data.length === 0;
          } else {
            // No order data returned for logged-in user - assume NOT first order for safety
            this.isFirstOrder = false;
          }
        },
        (error) => {
          // On error, don't apply first order discount to be safe
          this.isFirstOrder = false;
        }
      );
      return;
    }

    // No customerData or no CustomerId - could mean:
    // 1. Data hasn't loaded yet (default to false for safety)
    // 2. New customer in enrollment flow (already handled above)
    // 3. Guest checkout (default to false - they need to log in or complete enrollment)
    if (!customerData || !customerData?.CustomerId) {
      // Default to false - the checkout component will fetch fresh data and recalculate
      this.isFirstOrder = false;
      return;
    }
  }

  /**
   * Sets the first order flag directly (useful when the value is already known)
   * @param value - Whether this is the customer's first order
   */
  setFirstOrderFlag(value: boolean): void {
    this.isFirstOrder = value;
  }
}